/* eslint-disable react-hooks/exhaustive-deps */
import { isValidElement, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { atom, useRecoilState } from "recoil";

import uiConf from "../../config/uiConf";
import notificationState from "../../states/notificationState";

// 전역 알림(notificationState)을 그리는 Notification 은 그리드마다 하나씩 마운트된다 — 그리드가 둘 이상인 화면에서
// 같은 알림이 마운트 수만큼 겹치지 않도록 먼저 마운트된 하나만 그리고, 그 하나가 내려가면 남은 것이 이어받는다(GM-3042)
const notificationOwnerState = atom({
    key: "mainNotificationOwnerState",
    default: null,
});

let lastNotificationId = 0;

// 화면들이 실패 사유로 응답이 없는 오류 객체(Network Error 등)를 그대로 넘긴다 — 객체는 React 가 그리지 못해 화면이 백지가 되므로 글자로 바꾼다
const toText = ( msg ) =>
    msg === null || typeof msg !== "object" || isValidElement( msg ) ? msg : msg.message ?? JSON.stringify( msg );

function Notification ( props ) {

    const [ id ] = useState( () => ++lastNotificationId );
    const [ owner, setOwner ] = useRecoilState(notificationOwnerState);
    const [ notification, setNotification ] = useRecoilState(notificationState);

    useEffect( () => {

        if ( owner === null ) {

            setOwner( ( current ) => current ?? id );

        }

    }, [ owner ] );

    useEffect( () => () => setOwner( ( current ) => ( current === id ? null : current ) ), [] );

    const onCloseNotification = () => {

        setNotification( ( notification ) => {

            return ({...notification, open: false});

        } );

    };

    if ( owner !== id ) {

        return null;

    }

    // 그리는 하나가 숨은 탭 · 영역 안에 있어도 보이도록 body 에 그린다
    return ReactDOM.createPortal(
        <div>

            <Snackbar
                open={notification.open}
                autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                onClose={onCloseNotification}
            >
                <Alert
                    onClose={onCloseNotification}
                    variant="filled"
                    severity={notification.severity}
                >
                    { toText ( notification.msg ) }
                </Alert>
            </Snackbar>

        </div>,
        document.body
    );
}


export default Notification;
